export interface LinkGroup {
  title: string;
  links: { text: string; url: string }[];
}

export const PRODUCT_LINKS: LinkGroup = {
  title: 'Product',
  links: [
    { text: 'Community', url: '/community' },
    { text: 'Courses', url: '/online-courses' },
    { text: 'Members', url: '/members' },
    { text: 'Marketing', url: '/marketing' },
    { text: 'Payments', url: '/payments' },
    { text: 'Admin', url: '/admin' },
    { text: 'AI Cohost', url: '/ai' },
  ],
};

export const EXTENSIONS_LINKS: LinkGroup = {
  title: 'Extensions',
  links: [
    { text: 'APIs', url: 'https://docs.mightynetworks.com/guides' },
    { text: 'Integrations', url: '/integrations' },
    { text: 'Embeds', url: '/embeds' },
    { text: 'Automations', url: '/automations' },
  ],
};

export const PRICING_LINKS: LinkGroup = {
  title: 'Pricing',
  links: [
    { text: 'Launch Plan', url: '/pricing/launch' },
    { text: 'Scale Plan', url: '/pricing/scale' },
    { text: 'Growth Plan', url: '/pricing/growth' },
    { text: 'All Plans', url: '/pricing' },
  ],
};

export const MIGHTY_PRO_LINKS: LinkGroup = {
  title: 'Mighty Pro',
  links: [
    { text: 'Pro Features', url: '/pro' },
    { text: 'Pro Services', url: '/pro/services' },
    { text: 'Pro Case Studies', url: '/case-studies?mightyPlans=Mighty%20Pro' },
    { text: 'Non-Profits', url: '/pro/non-profit' },
  ],
};

export const SERVICES_LINKS: LinkGroup = {
  title: 'Services',
  links: [
    { text: 'Strategy', url: '/pro/services' },
    { text: 'Design', url: '/pro/services' },
    { text: 'Migration', url: '/migration' },
    { text: 'Mighty Experts', url: '/experts-directory' },
  ],
};

export const RESOURCES_LINKS: LinkGroup = {
  title: 'Resources',
  links: [
    { text: 'Book', url: 'https://purpose.co/' },
    {
      text: 'Podcast',
      url: 'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2?si=3810e7488d5f46aa&_ga=2.23953402.1174021151.1765514487-254950320.1748466885&ai=d70cf2ce-00bf-454b-a438-33bd9f45f071',
    },
    { text: 'Community Design', url: '/community-design' },
    { text: 'Case Studies', url: '/case-studies' },
    { text: 'Momentum List', url: '/momentum' },
    { text: 'Product Training', url: 'https://community.mightynetworks.com/spaces/12898937/content' },
    {
      text: 'Help Center',
      url: 'https://docs.mightynetworks.com/for-hosts/meet-mighty/watch-a-full-tour-of-a-mighty-network',
    },
  ],
};

export const COMPANY_LINKS: LinkGroup = {
  title: 'Company',
  links: [
    { text: 'About', url: '/about' },
    { text: 'Careers', url: '/careers' },
    { text: 'Trust Center', url: 'https://trust.mightynetworks.com/' },
    { text: 'Terms of Service', url: 'https://trust.mightynetworks.com/resources?s=pjz3xynjabbmiqp0xy99p&name=mighty-networks-terms-of-use' },
    { text: 'Privacy Policy', url: 'https://trust.mightynetworks.com/resources?s=ge3sk38fkeygii7yoqa1r1&name=mighty-networks-privacy-policy' },
    { text: 'Accessibility', url: '/accessibility' },
  ],
};

export const COMPARISONS_LINKS: LinkGroup = {
  title: 'Comparisons',
  links: [
    { text: 'Mighty vs. Circle', url: '/mighty-vs-circle' },
    { text: 'Mighty vs. Kajabi', url: '/resources/mighty-networks-vs-kajabi' },
    { text: 'Mighty vs. Skool', url: '/resources/mighty-networks-vs-skool' },
  ],
};
